import React, {useCallback, useState} from "react";
import {useNavigate, Link} from "react-router-dom"
import styles from './styles.module.scss';
import Button from "../../components/Button";
import { useModal } from '../../components/RegModal/ModalContext';
import {TryBtn} from "../../components/Try";

export default function Products() {

  const [hoverIndex, setHoverIndex] = useState(0)

  const handleHover = useCallback((index: number) => {
    setHoverIndex(index)
  }, [])


  return <section className={styles.products}>
    <div className={styles.detail}>
      <div className={`${styles.detailItem} ${hoverIndex === 0 ? styles.detailItemActive:""}`} onMouseEnter={() => {handleHover(0)}}>
        <div>
          <h3><img src="./static-official/images/arrow-title.svg" />科创金融数据平台</h3>
          <p>标准账号，支持搜索、 筛选、导出、问答等。</p>
          <img className={styles.img} src="./static-official/images/s-1.png" />
          <div className={styles.tryBtn}><TryBtn /></div>
        </div>
        <img className={styles.sticker} src={"./static-official/images/sticker-platform.png"}/>
      </div>
      <div className={`${styles.detailItem} ${hoverIndex === 1 ? styles.detailItemActive:""}`} onMouseEnter={() => {handleHover(1)}}>
        <div>
          <h3><img src="./static-official/images/arrow-title.svg" />数据库同步</h3>
          <p>API接口/数据库形式实时传输数据。</p>
          <p className={styles.omit}>内外部数据打通，更好地满足管理需求，提升机构数字化水平。</p>
          <img className={styles.img} src="./static-official/images/s-2.png" />
          <div className={styles.tryBtn}><TryBtn /></div>
        </div>
        <img className={styles.sticker} src={"./static-official/images/sticker-production.png"}/>
      </div>
      <div className={`${styles.detailItem} ${hoverIndex === 2 ? styles.detailItemActive:""}`} onMouseEnter={() => {handleHover(2)}}>
        <div>
          <h3><img src="./static-official/images/arrow-title.svg" />数据定制</h3>
          <p className={styles.omit}>面向银行、券商、政府园区、股权投资机构等提供垂直解决方案。</p>
          <p>可按需定制，一站式解决问题。</p>
          <img className={styles.img} src="./static-official/images/s-3.png" />
          <div className={styles.tryBtn}><TryBtn /></div>
        </div>
        <img className={styles.sticker} src={"./static-official/images/sticker-data.png"}/>
      </div>
    </div>
  </section>
}


const ViewMore = (props: {url: string}) => {
  const {url} = props
  const navigate = useNavigate()
  const { showModal } = useModal();

  return <div className={styles.viewMore}>
    <Button withArrow width="100%" onClick={showModal}>免费试用</Button>
    <Button type="default" withArrow width="100%" onClick={() => {navigate(url)}}>了解更多</Button>
  </div>
}
